import _classPrivateFieldGet from "@babel/runtime-corejs3/helpers/esm/classPrivateFieldGet";
import _Set from "@babel/runtime-corejs3/core-js/set";
import _valuesInstanceProperty from "@babel/runtime-corejs3/core-js/instance/values";
import _atInstanceProperty from "@babel/runtime-corejs3/core-js/instance/at";
import _bindInstanceProperty from "@babel/runtime-corejs3/core-js/instance/bind";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _WeakMap from "@babel/runtime-corejs3/core-js/weak-map";
function _classPrivateFieldInitSpec(obj, privateMap, value) { _checkPrivateRedeclaration(obj, privateMap); privateMap.set(obj, value); }
function _checkPrivateRedeclaration(obj, privateCollection) { if (privateCollection.has(obj)) { throw new TypeError("Cannot initialize the same private elements twice on an object"); } }
var _items = /*#__PURE__*/new _WeakMap();
var _eventTarget = /*#__PURE__*/new _WeakMap();
/**
 * Reactive Queue - a queue that emits an event when it changes
 */
class ReactiveQueue {
  constructor() {
    _classPrivateFieldInitSpec(this, _items, {
      writable: true,
      value: new _Set()
    });
    _classPrivateFieldInitSpec(this, _eventTarget, {
      writable: true,
      value: new EventTarget()
    });
  }
  get size() {
    return _classPrivateFieldGet(this, _items).size;
  }
  has(item) {
    return _classPrivateFieldGet(this, _items).has(item);
  }
  push(item) {
    _classPrivateFieldGet(this, _items).add(item);
    this.emitChange();
  }
  delete(item) {
    if (!_classPrivateFieldGet(this, _items).has(item)) {
      return;
    }
    _classPrivateFieldGet(this, _items).delete(item);
    this.emitChange();
  }
  peek() {
    var _context;
    if (_classPrivateFieldGet(this, _items).size === 0) {
      return undefined;
    }
    return _valuesInstanceProperty(_context = _classPrivateFieldGet(this, _items)).call(_context).next().value;
  }
  emitChange() {
    _classPrivateFieldGet(this, _eventTarget).dispatchEvent(new CustomEvent('change'));
  }
  addEventListener() {
    _classPrivateFieldGet(this, _eventTarget).addEventListener(...arguments);
  }
  removeEventListener() {
    _classPrivateFieldGet(this, _eventTarget).removeEventListener(...arguments);
  }
}
/**
 * Exposes a stack to inspect the "active" branch of the register tree.
 */
export const createActiveBranchStack = rootRegisterNode => {
  var _context2, _context3;
  let stackArray = [rootRegisterNode];
  const stackSet = new _Set(stackArray);
  const eventTarget = new EventTarget();
  const regenerateStack = () => {
    stackSet.clear();
    stackArray = [];
    let current = rootRegisterNode;
    while (current) {
      stackArray.push(current);
      stackSet.add(current);
      current = current.peek();
    }
    eventTarget.dispatchEvent(new CustomEvent('change'));
  };
  const stack = {
    get items() {
      return stackArray;
    },
    get size() {
      return stackArray.length;
    },
    has: item => stackSet.has(item),
    peek: () => _atInstanceProperty(stackArray).call(stackArray, -1),
    mount: () => {
      rootRegisterNode.addEventListener('change', regenerateStack);
    },
    unmount: () => {
      rootRegisterNode.removeEventListener('change', regenerateStack);
    },
    addEventListener: _bindInstanceProperty(_context2 = eventTarget.addEventListener).call(_context2, eventTarget),
    removeEventListener: _bindInstanceProperty(_context3 = eventTarget.removeEventListener).call(_context3, eventTarget)
  };
  return stack;
};
let id = 0;
const withDebuggingProperties = (obj, queue) => _Object$defineProperties(obj, {
  id: {
    // eslint-disable-next-line no-plusplus
    value: id++
  },
  queue: {
    value: queue
  },
  // API to behave like a react ref that can be used
  // to easily store HTML elements
  current: {
    writable: true,
    value: null
  }
});
export const createRegisterNode = () => {
  var _context4, _context5;
  const queue = new ReactiveQueue();
  const forwardChangeToParent = () => {
    queue.emitChange();
  };
  const addEventListener = _bindInstanceProperty(_context4 = queue.addEventListener).call(_context4, queue);
  const removeEventListener = _bindInstanceProperty(_context5 = queue.removeEventListener).call(_context5, queue);
  return withDebuggingProperties({
    addEventListener,
    removeEventListener,
    has: item => queue.has(item),
    peek: () => queue.peek(),
    get size() {
      return queue.size;
    },
    addChild: item => {
      if (queue.has(item)) {
        return;
      }
      queue.push(item);
      item.addEventListener('change', forwardChangeToParent);
    },
    removeChild: item => {
      queue.delete(item);
      item.removeEventListener('change', forwardChangeToParent);
    }
  }, queue);
};